export const productPlanificationHeaderElements = [
  { label: "Fecha", value: "displayFechaCreacion", align: "inherit" },
  { label: "Titular cuenta", value: "displayTitularCuenta", align: "inherit" },
  { label: "Cultivo", value: "nombreCultivo", align: "inherit" },
  { label: "HA propias", value: "hectareasPropias", align: "inherit" },
  { label: "HA alquiladas", value: "hectareasAlquiladas", align: "inherit" },
  { label: "Desvío", value: "displayDesvio", align: "center" },
  { label: "Estado", value: "estado", align: "inherit" },
];
